import { StoreStatuses } from "../enums/store/storeStatuses";

export type Store = {
  storeId: string;
  name: string;
  status: StoreStatuses;
  locales: string[];
  primaryLocale: string;
  countryId: string;
  timezone: string;
  isVirtual: boolean;
  createdAt: Date;
  updatedAt?: Date | undefined;
};

export const excludedStoreIds = [
  "012#fixa-team",
  "064#fixa-team",
  "006#fixa-team",
];
